import React from "react";
import { useRouteError } from "react-router-dom";

const GlobalErrorElement: React.FC = () => {
  const error = useRouteError();
  console.error("Caught by GlobalErrorElement:", error);
  return null
  // return (
  //   <div style={{ textAlign: "center", marginTop: "20%" }}>
  //     <h1>Oops! Something went wrong.</h1>
  //     <p>
  //       {error instanceof Error ? error.message : "An unknown error occurred."}
  //     </p>
  //   </div>
  // );
};

export default GlobalErrorElement;
